import React, {useEffect, useCallback} from 'react';
import {useDispatch} from 'react-redux';
import {Redirect} from 'react-router-dom';

import * as actions from "../../../store/actions"

const Logout = (props) => {

    const dispatch = useDispatch()
    const onLogout = useCallback(() => dispatch(actions.logout()), [dispatch])

    useEffect(() => {
        onLogout()
    }, [onLogout])

    const redirectTo = new URLSearchParams(props.location.search).get("goto")
    return <Redirect to={redirectTo ? "/" + redirectTo : "" }/>
}

export default Logout;